// Shared settings for the three global controls in the page chrome —
// Autopilot, the theme switch, and the notification bell.
//
// This is a plain module with NO imports on purpose. The constant first lived
// inside one of the controls, which meant importing it dragged that whole
// component in: ThemeToggle picked up `react-router-dom` transitively and its
// test suite stopped being able to run at all. A shared value that forces its
// consumers to depend on a component is not shared, it is coupled.
//
// Hover delay: the bell used 200ms and the theme control the Radix default
// (~700ms). Three adjacent controls disagreeing about when their labels appear
// reads as one of them being broken, so they now agree by construction.
export const TOOLTIP_DELAY_MS = 200;
